import headers from './headers'

export default function(fetch) {
  return function(backgroundId, perMeter) {
    return fetch(`${process.env.REACT_APP_API_URL}/user_backgrounds/${backgroundId}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify({ perMeter }),
    }).then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/calibreBackground.js